import * as React from "react";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function Contactinformation() {
  return <section data-section-id="239488" id="contactinformation" className="bg-background text-foreground overflow-hidden ![padding:40px_0px_96px_0px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          <div className="space-y-10">
            <div>
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl text-foreground mb-6 tracking-tight">
                Contáctanos
              </h2>
              <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-md">
                Estamos listos para potenciar tus comunicaciones. Visítanos o contacta a nuestros expertos en soluciones de telecomunicaciones para una asesoría personalizada.
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex items-start gap-5">
                <div className="bg-primary/10 p-4 rounded-lg shrink-0">
                  <MapPin className="w-7 h-7 text-primary" />
                </div>
                <div className="pt-1">
                  <h3 className="font-default text-2xl text-foreground mb-2 tracking-wide">
                    Oficina Central
                  </h3>
                  <p className="font-sans text-lg text-muted-foreground leading-relaxed">
                    Condominio Santa Verde, Edificio Laurel<br />
                    Tercer Piso, Oficina 0306<br />
                    Heredia, Costa Rica
                  </p>
                  <div className="flex gap-4 mt-3">
                    <Link to="https://www.google.com/maps/dir/?api=1&destination=9.990123,-84.148066" newTab className="text-primary text-sm font-semibold hover:underline flex items-center gap-1">
                      Google Maps
                    </Link>
                    <Link to="https://waze.com/ul?ll=9.990123,-84.148066&navigate=yes" newTab className="text-primary text-sm font-semibold hover:underline flex items-center gap-1">
                      Waze
                    </Link>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="bg-primary/10 p-4 rounded-lg shrink-0">
                  <Phone className="w-7 h-7 text-primary" />
                </div>
                <div className="pt-1">
                  <h3 className="font-default text-2xl text-foreground mb-2 tracking-wide">
                    Línea de Atención
                  </h3>
                  <p className="font-sans text-lg text-muted-foreground leading-relaxed">
                    +506 2263-3278 / +506 4040-0882
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4 flex flex-col sm:flex-row flex-wrap gap-4">
              <Link to="https://wa.me/50687176886" newTab>
                <Button size="lg" className="rounded-md px-8 py-7 text-lg gap-3 w-full sm:w-auto shadow-md shadow-primary/10 hover:shadow-lg hover:scale-[1.02] transition-all duration-300 bg-primary text-primary-foreground">
                  <MessageCircle className="w-6 h-6" />
                  Chat por WhatsApp
                </Button>
              </Link>
              <a href="tel:+50622633278">
                <Button variant="outline" size="lg" className="rounded-md px-8 py-7 text-lg gap-3 w-full sm:w-auto shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300">
                  <Phone className="w-6 h-6" />
                  Llamar Ahora
                </Button>
              </a>
              <Link to="#agende-asesoria-form">
                <Button size="lg" className="rounded-md px-8 py-7 text-lg w-full sm:w-auto shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 bg-yellow-400 text-black font-bold border-none">
                  Solicitar Información
                </Button>
              </Link>
            </div>
          </div>

          <div className="relative h-[350px] lg:h-[420px] rounded-lg overflow-hidden shadow-xl border border-border/50 group">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.568!2d-84.1479626!3d9.9895572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNTknMjIuNCJOIDg0wrAwOCc1Mi43Ilc!5e0!3m2!1sen!2scr!4v1710000000000!5m2!1sen!2scr" className="absolute inset-0 w-full h-full border-0 grayscale-[0.2] contrast-[1.1]" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de la oficina de AVTECSA" />
            
            <div className="absolute inset-0 bg-accent/5 pointer-events-none" />

            <Card className="absolute bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-card/95 backdrop-blur-md border-border/50 shadow-md p-5 rounded-md">
              <h4 className="font-default text-xl text-foreground tracking-wide">Sede Avtec</h4>
              <p className="font-sans text-sm text-muted-foreground mt-2 leading-relaxed">
                Horario: Lunes a Viernes 8:00 AM - 5:00 PM<br />
                Estacionamiento disponible bajo techo
              </p>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}